import React from 'react'
import moment from 'moment'
import { Switch } from '@blueprintjs/core'
import { get } from 'lodash'
import track from '@track'
import { ILeases } from './hooks/useLeases'
import DateFilter from './DateFilter'
import { any } from 'lodash/fp'

interface Props {
  leases: ILeases
}
export default function Filters({ leases }: Props) {
  const endDate = get(leases, 'filters.date.endDate.value', null)
  const noticeDate = get(leases, 'filters.date.noticeDate.value', null)

  return (
    <div className="ph2 pv1 filters" onClick={(e) => e.stopPropagation()}>
      <table>
        <tbody>
          <tr>
            <td>Exp. Date</td>
            <td>
              <DateFilter
                label="Select"
                prefix="Expires Within"
                value={endDate}
                name="endDate"
                defaultVal={{
                  label: '',
                  fromDate: moment().toDate(),
                  toDate: undefined,
                }}
                onChange={(value) => {
                  track.lease({
                    eventName: track.Event.FILTER,
                    props: {
                      filterName: 'End Date',
                      filterValue: value,
                    },
                  })
                  leases.filter({
                    kind: 'date',
                    key: 'endDate',
                    value,
                  })
                }}
              />
            </td>
          </tr>
          <tr>
            <td>Notice Date</td>
            <td>
              <DateFilter
                label="Select"
                prefix="Notifies Within"
                value={noticeDate}
                name="noticeDate"
                onChange={(value) => {
                  track.lease({
                    eventName: track.Event.FILTER,
                    props: {
                      filterName: 'Notice Date',
                      filterValue: value,
                    },
                  })
                  leases.filter({
                    kind: 'date',
                    key: 'noticeDate',
                    value,
                  })
                }}
              />
            </td>
          </tr>
          <tr>
            <td>Show Expired</td>
            <td>
              <Switch
                checked={!get(leases, 'filters.date.endDate.value.fromDate')}
                style={{ margin: 0, width: 'min-content' }}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const fromDate = e.target.checked ? undefined : moment().toDate()
                  leases.filter({
                    kind: 'date',
                    key: 'endDate',
                    value: {
                      fromDate,
                      toDate: get(leases, 'filters.date.endDate.value.toDate'),
                      label: get(leases, 'filters.date.endDate.value.label', ''),
                    },
                  })
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
